// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HomePage_wrapper__vFNr5","container":"HomePage_container__3eEZw","section":"HomePage_section__1CAZT","h2":"HomePage_h2__2TAje"};